module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/195-france-bce15fd8ed6fdb66c12a06531e3ec9cd.svg";